import React from "react";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";
import { Alert } from "@material-ui/lab";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";

const Text = ({ text, status }) => {
    const color = useSelector(getAppColor);

    if (status?.toUpperCase() === "ERROR") {
        return (
            <Alert
                variant="filled"
                severity="error"
                style={{ display: "flex", alignItems: "center", margin: "5px 0px" }}
            >
                {text}
            </Alert>
        );
    }

    return (
        <ReactMarkdown
            plugins={[gfm]}
            components={{
                a: ({ node, children, ...props }) => (
                    <a {...props} target="_blank" rel="noopener noreferrer" style={{ color: color }}>
                        {children}
                    </a>
                ),
                p: ({ node, children, ...props }) => (
                    <p
                        {...props}
                        style={{
                            margin: "5px 0px",
                            wordBreak: "break-word",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        {children}
                    </p>
                ),
                pre: ({ node, children, ...props }) => (
                    <pre
                        {...props}
                        style={{
                            padding: 16,
                            tabSize: 4,
                            textWrap: "auto",
                            fontFamily: "monospace",
                            borderRadius: 8,
                            background: "rgba(0, 0, 0, 0.2)",
                        }}
                    >
                        {children}
                    </pre>
                ),
                code: ({ node, children, ...props }) => (
                    <code
                        {...props}
                        style={{
                            textWrap: "auto",
                            background: "rgba(0, 0, 0, 0.3)",
                            fontFamily: 'Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace',
                            fontSize: "0.85rem",
                        }}
                    >
                        {children}
                    </code>
                ),
            }}
        >
            {text}
        </ReactMarkdown>
    );
};

export default Text;
